<mat-form-field2 class="mat-block" [showLabel]="showLabel">
  <mat-label>{{ label || placeholder }}</mat-label>
  <input
    type="text"
    [formControl]="ctrl"
    [required]="ctrl | required"
    matInput
    [placeholder]="placeholder"
    [errorStateMatcher]="matcher"
  />

  <i [ngClass]="prefixIcon" matPrefix *ngIf="showPrefix"></i>
  <button
    type="button"
    class="btn btn-sm btn-secondary-info"
    matSuffix
    (click)="onValidate()"
    matTooltip="Validate phone number"
    i18n-matTooltip
    style="margin-right: -0.5rem"
    *ngIf="showValidateBtn && isValidatable"
  >
    <i class="cs-icon cs-icon-check text-xs" *ngIf="!isLoading"></i>
    <span class="far fa-spinner fa-spin" *ngIf="isLoading"></span>
  </button>
  <mat-error *ngIf="ctrl.touched && ctrl.hasError('required')">
    <ng-container i18n>Phone is required</ng-container>
  </mat-error>
  <mat-error *ngIf="ctrl.hasError('allSpaces')">
    <ng-container i18n>Phone cannot be spaces alone.</ng-container>
  </mat-error>
  <mat-error *ngIf="ctrl.hasError('phone')">
    <ng-container i18n>Phone number is invalid.</ng-container>
  </mat-error>
  <mat-hint class="text-success text-nowrap" *ngIf="phoneValidationResult?.valid === true">
    <ng-container i18n>This phone number is valid.</ng-container>
    <span class="text-bold ml-1">{{ phoneValidationResult.format }}</span>
  </mat-hint>
  <mat-hint *ngIf="hint && !phoneValidationResult">{{ hint }}</mat-hint>
</mat-form-field2>
